interface Props {
  label?: string;
  title: string;
  description?: string;
  center?: boolean;
}

export default function SectionHeading({ label, title, description, center = true }: Props) {
  return (
    <div className={`mb-12 ${center ? 'text-center' : ''}`}>
      {label && (
        <span className="inline-block px-4 py-1.5 rounded-full bg-secondary text-primary text-xs font-semibold uppercase tracking-widest mb-4">
          {label}
        </span>
      )}
      <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">{title}</h2>
      {description && <p className="text-muted-foreground text-lg max-w-2xl mx-auto leading-relaxed">{description}</p>}
    </div>
  );
}
